import UsersDelete from './UsersDelete';

export default UsersDelete;
